import { PercentageOutlined } from '@ant-design/icons';

import { DAY_OF_WEEK } from 'app/typings/core/common/enum/dayOfWeek';

import { ExpandableCard } from '../ExpandableCard/ExpandableCard';

import { RoomDiscountContent } from './_components/RoomDiscountContent';
import { useRoomDiscountLogic } from './hooks/useRoomDiscountLogic';

type RoomDiscountProps = {
  isExpanded: boolean;
  onToggle: () => void;
};

export const RoomDiscount = ({ isExpanded, onToggle }: RoomDiscountProps) => {
  const {
    currencyFormatter,
    formRoomPrice,
    discountMode,
    defaultNightRoomDiscount,
    defaultNightRoomDiscountDays,
    getDayBasePrice,
    handleDiscountModeChange,
    lastMinuteNightRoomDiscountRate,
    isLastMinuteEnabled,
    handleLastMinuteToggle,
    handleDiscountToggle,
    isDiscountEnabled,
  } = useRoomDiscountLogic();

  const dailyValues = Object.values(defaultNightRoomDiscountDays ?? {}).filter(
    (value): value is number => value !== null && value !== undefined
  );
  const dailyAverage =
    dailyValues.length > 0
      ? Math.round(
          dailyValues.reduce((sum, value) => sum + value, 0) /
            dailyValues.length
        )
      : undefined;
  const hasMissingDailyDiscount = Object.values(DAY_OF_WEEK).some((day) => {
    const value = defaultNightRoomDiscountDays?.[day];

    return value === null || value === undefined;
  });
  const isUniformDaily =
    !hasMissingDailyDiscount &&
    dailyValues.length > 0 &&
    dailyValues.every((value) => value === dailyValues[0]);

  const isDefaultDiscountMissing =
    isDiscountEnabled &&
    (discountMode === 'DAILY'
      ? hasMissingDailyDiscount
      : defaultNightRoomDiscount === null ||
        defaultNightRoomDiscount === undefined);

  const tag =
    discountMode === 'DAILY'
      ? dailyAverage !== undefined
        ? `-${dailyAverage}%`
        : undefined
      : defaultNightRoomDiscount !== null &&
          defaultNightRoomDiscount !== undefined
        ? `-${defaultNightRoomDiscount}%`
        : undefined;

  return (
    <ExpandableCard
      sectionTitle="ROOM PRICING RULE"
      title="Room Discounts"
      icon={<PercentageOutlined />}
      tag={tag}
      tagLabel={
        discountMode === 'DAILY' && !isUniformDaily
          ? 'Average discount'
          : undefined
      }
      errorMessage={
        formRoomPrice === null || formRoomPrice === undefined
          ? 'Average BAR required'
          : isDefaultDiscountMissing
            ? 'Discount required'
            : undefined
      }
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      <RoomDiscountContent
        currencyFormatter={currencyFormatter}
        formRoomPrice={formRoomPrice}
        discountMode={discountMode}
        defaultNightRoomDiscount={defaultNightRoomDiscount}
        defaultNightRoomDiscountDays={defaultNightRoomDiscountDays}
        getDayBasePrice={getDayBasePrice}
        onDiscountModeChange={handleDiscountModeChange}
        lastMinuteNightRoomDiscountRate={lastMinuteNightRoomDiscountRate}
        isLastMinuteEnabled={isLastMinuteEnabled}
        onLastMinuteToggle={handleLastMinuteToggle}
        onDiscountToggle={handleDiscountToggle}
        isDiscountEnabled={isDiscountEnabled}
      />
    </ExpandableCard>
  );
};
